<div class="remova_padding topo" *ngIf="isMobile">
  <nav class="navbar navbar-expand-lg" [ngClass]="{'fixed-top': isMobile}" style="background: #fff;z-index: 9999999;">
    <div class="row" style="flex-grow: 1;">
      <div class="pl-2 span3 text-left position-absolute" style="margin-top: 3px;margin-left: 5px;z-index: 999">
        <button class="btn shadow-none" (click)="voltar()" style="margin-right: 5px;">
          <i class="fas fa-chevron-left" style="color: #000"></i>
        </button>
      </div>
      <div class="col pl-1" style="position: relative;text-align: center">
        <h4> {{empresa.nome}}</h4>
      </div>
    </div>
  </nav>
</div>

<div style="height: 54px;width: 100%" *ngIf="isMobile">
</div>


<app-pagina></app-pagina>
